import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <img 
                src="/logo-freelanceurs.png" 
                alt="FREELANCEURS.io" 
                className="h-10 w-auto"
              />
              <span className="font-manrope font-bold text-xl text-white">
                Freelanceurs<span className="text-[#52fbb0]">.io</span>
              </span>
            </div>
            <p className="text-slate-400 text-sm leading-relaxed">
              Votre partenaire pour réussir en freelance. Conseils experts, outils pratiques et accompagnement personnalisé.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-manrope font-semibold text-white mb-4">Navigation</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm">Accueil</Link></li>
              <li><Link to="/simulateur" className="text-sm">Simulateur de statuts</Link></li>
              <li><Link to="/services" className="text-sm">Nos services</Link></li>
              <li><Link to="/a-propos" className="text-sm">À propos</Link></li>
              <li><Link to="/blog" className="text-sm">Blog & Ressources</Link></li>
              <li><Link to="/contact" className="text-sm">Contact</Link></li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-manrope font-semibold text-white mb-4">Ressources</h4>
            <ul className="space-y-3">
              <li><Link to="/simulateur" className="text-sm">Comparateur de statuts</Link></li>
              <li><Link to="/blog" className="text-sm">Guides pratiques</Link></li>
              <li><Link to="/blog" className="text-sm">Fiscalité freelance</Link></li>
              <li><Link to="/blog" className="text-sm">Optimisation sociale</Link></li>
              <li>
                <a
                  href="https://freelanceurs.app"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm inline-flex items-center gap-1"
                >
                  Support & Ticketing
                  <ArrowUpRight className="h-3 w-3" />
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-manrope font-semibold text-white mb-4">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="h-5 w-5 text-[#52fbb0] mt-0.5" />
                <span className="text-sm">contact@freelanceurs.io</span>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#52fbb0] mt-0.5" />
                <span className="text-sm">445 Bd Gambetta<br />59200 Tourcoing</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} Freelanceurs.io. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/contact" className="text-slate-500 hover:text-slate-300 text-sm">
              Mentions légales
            </Link>
            <Link to="/contact" className="text-slate-500 hover:text-slate-300 text-sm">
              Politique de confidentialité
            </Link>
            <Link to="/contact" className="text-slate-500 hover:text-slate-300 text-sm">
              CGU
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
